import imgEmptyList from '@/assets/images/empty-list.png';
import { imgEmptySearch, imgEmptyData } from '@/constants/imgContent';
export default {
  props: {
    title: {
      type: String
    },
    type: {
      type: String,
      default: 'empty'
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    images() {
      return {
        empty: imgEmptyData[this.theme],
        emptySearch: imgEmptySearch[this.theme],
        emptyList: imgEmptyList
      };
    },
    theme() {
      return this.$store.state.theme || ''; // 获取主题
    }
  },

  methods: {},
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};